import { render, staticRenderFns } from "./pushError.vue?vue&type=template&id=4822c5c2&"
import script from "./pushError.vue?vue&type=script&lang=js&"
export * from "./pushError.vue?vue&type=script&lang=js&"
import style0 from "./pushError.vue?vue&type=style&index=0&id=4822c5c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports